import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Warning } from 'shared/assets/icons';
import { PriorityPickerMenu } from 'shared/components/ui/priority-picker-menu/priority-picker-menu';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { TaskPriorityOptions } from 'shared/types/task-base';

import { MetaInteraction } from '../meta-interaction/meta-interaction';

export type MetaPriorityProps = {
  value?: TaskPriorityOptions | null;
  onChange: (value: TaskPriorityOptions | null) => void;
};

export const MetaPriority: React.FC<MetaPriorityProps> = ({
  value,
  onChange,
}) => {
  const { t } = useTranslation();
  const buttonRef = useRef<HTMLButtonElement>(null);
  const { menuOpen, openMenu, closeMenu } = useOpenMenu();

  const onClear = () => {
    onChange(null);
    closeMenu();
  };

  return (
    <>
      <MetaInteraction
        ref={buttonRef}
        icon={Warning}
        placeholder={t('dialogs.task-detail.meta.priority.placeholder')}
        label={value ? t(`task.priority.options.${value}.label`) : undefined}
        onClick={openMenu}
        onClear={value ? onClear : undefined}
      />

      {menuOpen && (
        <PriorityPickerMenu
          referenceElement={buttonRef}
          onClose={closeMenu}
          value={value}
          onChange={onChange}
        />
      )}
    </>
  );
};
